import { __rest } from "tslib";
import React from 'react';
import Button from '../../button/button';
import RRLink from '../RRLink';
const RRLinkButton = (_a) => {
    var { href, children, dataTest, onClick, gtm, target, rel, disabled } = _a, buttonProps = __rest(_a, ["href", "children", "dataTest", "onClick", "gtm", "target", "rel", "disabled"]);
    return disabled ? (React.createElement(Button, Object.assign({}, buttonProps, { disabled: true, dataTest: dataTest, gtm: gtm, type: "button" }), children)) : (React.createElement(RRLink, { href: href, target: target, rel: rel, text: false, external: false, dataTest: dataTest, gtm: gtm, onClick: onClick },
        React.createElement(Button, Object.assign({}, buttonProps, { dataTest: dataTest, gtm: gtm, type: "button" }), children)));
};
export default RRLinkButton;
//# sourceMappingURL=rr-link-button.js.map